import { Link, useLocation } from "react-router-dom";
import { Home, MapPin, Package, Stethoscope } from "lucide-react";
import Layout from "@/components/Layout";
import { useDocumentHead } from "@/hooks/useDocumentHead";

/* the main sections to go on to */
const SECTIONS = [
  { to: "/", label: "Home", icon: Home },
  { to: "/top-ayurvedic-centers-in-india", label: "Top Centres", icon: MapPin },
  { to: "/ayurveda-packages", label: "Ayurveda Packages", icon: Package },
  { to: "/ayurveda-treatments", label: "Ayurveda Treatments", icon: Stethoscope },
];

/**
 * The page for an address the site does not have, old addresses included
 * (the live server sends it with a 404 status, from /404.html): MyVaidyam's
 * header and footer, a short message and the main sections. noindex, and no
 * canonical, so search engines drop the address.
 */
const NotFound = () => {
  const { pathname } = useLocation();
  useDocumentHead({
    title: "Page Not Found | MyVaidyam",
    description: "This page does not exist on MyVaidyam. Explore Ayurveda centres, packages and treatments in India.",
    robots: "noindex, follow",
  });

  return (
    <Layout>
      <section className="bg-[#F3F7F5] px-4 py-16 md:py-24">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-6xl font-bold leading-none text-[#C24E00] md:text-7xl">404</p>
          <h1 className="mt-4 text-2xl font-bold text-[#2C4E5A] md:text-3xl">Page not found</h1>
          <p className="mx-auto mt-3 max-w-xl text-[15px] leading-relaxed text-[#2C4E5A]/80">
            The page <span className="break-all font-semibold text-[#2C4E5A]">{pathname}</span> does not exist on MyVaidyam.
            It may have been moved or removed.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {SECTIONS.map(({ to, label, icon: Icon }) => (
              <Link
                key={to}
                to={to}
                className="flex flex-col items-center gap-2 rounded-xl border border-[#2C4E5A]/10 bg-white px-3 py-4 text-sm font-semibold text-[#2C4E5A] shadow-sm transition-colors hover:border-[#C24E00]/40 hover:text-[#C24E00]"
              >
                <Icon className="h-5 w-5 text-[#C24E00]" aria-hidden="true" />
                {label}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
